(function () {
  'use strict';

  // ── Config ──────────────────────────────────────────────────────────
  var SOILIFE_PRODUCTS = [
    {
      handle: 'soil-microbes-feeder',
      title: 'Soil Microbes + Feeder',
      url: '/products/soil-microbes-feeder',
      image: null // fetched dynamically
    },
    {
      handle: 'kelp-power',
      title: 'Kelp Power',
      url: '/products/kelp-power',
      image: null
    },
    {
      handle: 'compost-microbes',
      title: 'Compost Microbes',
      url: '/products/compost-microbes',
      image: null
    }
  ];

  var BANNER_ID = 'soilife-cart-upsell-banner';
  var CSS_ID = 'soilife-cart-upsell-css';
  var DISMISSED_KEY = 'soilife_upsell_dismissed';

  // ── Tier messages ───────────────────────────────────────────────────
  var MESSAGES = {
    1: '\uD83C\uDF31 Add a 2nd product and save 6%! Use SHIP40% for 40% off shipping!',
    2: '\uD83C\uDF3F Add a 3rd product and save 12% \u2014 your garden (and wallet) will love you!',
    3: "\uD83C\uDF3B You're getting the best deal! 12% off + use SHIP40% for 40% off shipping!"
  };

  // ── Inject CSS once ─────────────────────────────────────────────────
  function injectStyles() {
    if (document.getElementById(CSS_ID)) return;

    var css = [
      '#' + BANNER_ID + ' {',
      '  background: #F7FAF5;',
      '  border-left: 4px solid #9ec658;',
      '  border-radius: 8px;',
      '  padding: 16px;',
      '  margin: 0 0 16px;',
      '  position: relative;',
      '  font-family: "Poppins", sans-serif;',
      '  box-sizing: border-box;',
      '}',
      '#' + BANNER_ID + ' .scu-dismiss {',
      '  position: absolute;',
      '  top: 8px;',
      '  right: 10px;',
      '  background: none;',
      '  border: none;',
      '  font-size: 18px;',
      '  line-height: 1;',
      '  color: #8a8a8a;',
      '  cursor: pointer;',
      '  padding: 0 4px;',
      '}',
      '#' + BANNER_ID + ' .scu-dismiss:hover {',
      '  color: #113B2B;',
      '}',
      '#' + BANNER_ID + ' .scu-message {',
      '  font-size: 14px;',
      '  font-weight: 700;',
      '  color: #113B2B;',
      '  margin: 0 0 10px;',
      '  padding-right: 20px;',
      '}',
      '#' + BANNER_ID + ' .scu-products {',
      '  display: flex;',
      '  align-items: center;',
      '  gap: 12px;',
      '  flex-wrap: wrap;',
      '}',
      '#' + BANNER_ID + ' .scu-product {',
      '  display: flex;',
      '  align-items: center;',
      '  gap: 10px;',
      '  text-decoration: none;',
      '  background: #fff;',
      '  border: 1px solid #e0e8dc;',
      '  border-radius: 10px;',
      '  padding: 12px;',
      '  margin-top: 8px;',
      '}',
      '#' + BANNER_ID + ' .scu-thumb {',
      '  width: 40px;',
      '  height: 40px;',
      '  border-radius: 50%;',
      '  object-fit: cover;',
      '  border: 2px solid #9ec658;',
      '  flex-shrink: 0;',
      '}',
      '#' + BANNER_ID + ' .scu-add-link {',
      '  font-family: "Poppins", sans-serif;',
      '  font-size: 13px;',
      '  color: #9ec658;',
      '  text-decoration: underline;',
      '  font-weight: 600;',
      '}',
      '#' + BANNER_ID + ' .scu-add-link:hover {',
      '  color: #113B2B;',
      '}',
      '#' + BANNER_ID + ' .scu-complete {',
      '  display: flex;',
      '  align-items: center;',
      '  gap: 6px;',
      '}',
      '#' + BANNER_ID + ' .scu-check {',
      '  color: #9ec658;',
      '  font-size: 18px;',
      '}'
    ].join('\n');

    var style = document.createElement('style');
    style.id = CSS_ID;
    style.textContent = css;
    document.head.appendChild(style);
  }

  // ── Fetch product images on first run ───────────────────────────────
  var imagesFetched = false;

  function fetchProductImages(callback) {
    if (imagesFetched) {
      callback();
      return;
    }

    var pending = SOILIFE_PRODUCTS.length;

    SOILIFE_PRODUCTS.forEach(function (product) {
      fetch('/products/' + product.handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.featured_image) {
            product.image = data.featured_image;
          }
          product.available = data && data.available;
          product.variants = data && data.variants ? data.variants : [];
        })
        .catch(function () {
          // Silently fail - thumbnail just won't show
        })
        .finally(function () {
          pending--;
          if (pending === 0) {
            imagesFetched = true;
            callback();
          }
        });
    });
  }

  // ── Fetch cart and render ───────────────────────────────────────────
  function fetchCartAndRender() {
    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        processCart(cart);
      })
      .catch(function () {
        // Cart fetch failed - remove banner if present
        removeBanner();
      });
  }

  function processCart(cart) {
    // Check if user dismissed for this session
    if (sessionStorage.getItem(DISMISSED_KEY)) {
      removeBanner();
      return;
    }

    // Identify which SoiLife products are in the cart
    var handlesInCart = {};
    var soiHandles = SOILIFE_PRODUCTS.map(function (p) { return p.handle; });

    cart.items.forEach(function (item) {
      var h = item.handle || '';
      if (soiHandles.indexOf(h) !== -1) {
        handlesInCart[h] = true;
      }
    });

    var count = Object.keys(handlesInCart).length;

    // If no SoiLife products, remove banner
    if (count === 0) {
      removeBanner();
      return;
    }

    // Determine missing products (exclude out-of-stock)
    var missing = SOILIFE_PRODUCTS.filter(function (p) {
      return !handlesInCart[p.handle] && p.available !== false;
    });

    // Determine tier (cap at 3)
    var tier = count >= 3 ? 3 : count;
    var message = MESSAGES[tier];

    // Fetch images then render
    fetchProductImages(function () {
      renderBanner(message, missing, tier);
    });
  }

  // ── Render the banner ───────────────────────────────────────────────
  function renderBanner(message, missingProducts, tier) {
    injectStyles();

    // Remove existing banner before re-rendering
    removeBanner();

    var banner = document.createElement('div');
    banner.id = BANNER_ID;

    // Dismiss button
    var dismiss = document.createElement('button');
    dismiss.className = 'scu-dismiss';
    dismiss.setAttribute('aria-label', 'Dismiss upsell banner');
    dismiss.textContent = '\u00D7';
    dismiss.addEventListener('click', function () {
      sessionStorage.setItem(DISMISSED_KEY, '1');
      removeBanner();
    });
    banner.appendChild(dismiss);

    // Message text
    var msg = document.createElement('p');
    msg.className = 'scu-message';
    msg.textContent = message;
    banner.appendChild(msg);

    // Product cards with inline variant selector + ATC (tiers 1 & 2)
    if (tier < 3 && missingProducts.length > 0) {
      var productsWrap = document.createElement('div');
      productsWrap.className = 'scu-products';

      missingProducts.forEach(function (product) {
        var card = document.createElement('div');
        card.className = 'scu-product';

        if (product.image) {
          var img = document.createElement('img');
          img.className = 'scu-thumb';
          img.src = product.image;
          img.alt = product.title;
          img.loading = 'lazy';
          card.appendChild(img);
        }

        var infoWrap = document.createElement('div');
        infoWrap.style.cssText = 'display:flex;flex-direction:column;gap:6px;flex:1;';

        var nameEl = document.createElement('span');
        nameEl.style.cssText = 'font-size:13px;font-weight:700;color:#113B2B;font-family:"Poppins",sans-serif;';
        nameEl.textContent = product.title;
        infoWrap.appendChild(nameEl);

        // Variant selector + ATC row
        var actionsRow = document.createElement('div');
        actionsRow.style.cssText = 'display:flex;align-items:center;gap:8px;flex-wrap:wrap;';

        // Size selector dropdown
        if (product.variants && product.variants.length > 1) {
          var select = document.createElement('select');
          select.style.cssText = 'padding:6px 10px;border:1px solid #e0e8dc;border-radius:6px;font-family:"Poppins",sans-serif;font-size:12px;color:#113B2B;background:#fff;cursor:pointer;';
          product.variants.forEach(function (v) {
            if (!v.available) return;
            var opt = document.createElement('option');
            opt.value = v.id;
            opt.textContent = v.title + ' - $' + (v.price / 100).toFixed(2);
            select.appendChild(opt);
          });
          actionsRow.appendChild(select);
        }

        // ATC button
        var atcBtn = document.createElement('button');
        atcBtn.style.cssText = 'background:#113B2B;color:#fff;border:none;border-radius:6px;padding:7px 14px;font-family:"Poppins",sans-serif;font-size:12px;font-weight:700;cursor:pointer;white-space:nowrap;transition:background 0.2s;';
        atcBtn.textContent = '+ Add';
        atcBtn.addEventListener('mouseenter', function () { atcBtn.style.background = '#9ec658'; });
        atcBtn.addEventListener('mouseleave', function () { atcBtn.style.background = '#113B2B'; });
        atcBtn.addEventListener('click', function () {
          var variantId;
          var selectEl = card.querySelector('select');
          if (selectEl) {
            variantId = selectEl.value;
          } else if (product.variants && product.variants.length > 0) {
            var firstAvailable = product.variants.find(function (v) { return v.available; });
            variantId = firstAvailable ? firstAvailable.id : product.variants[0].id;
          }
          if (!variantId) return;

          atcBtn.textContent = 'Adding...';
          atcBtn.disabled = true;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
          })
          .then(function (r) { return r.json(); })
          .then(function () {
            atcBtn.textContent = 'Added \u2713';
            atcBtn.style.background = '#9ec658';
            // Dispatch event for cart-confirm panel
            document.dispatchEvent(new CustomEvent('soilife:cart:added'));
            // Refresh the upsell banner after a delay
            setTimeout(function () {
              fetchCartAndRender();
              // Also refresh the cart page if we're on it
              var cartForm = document.querySelector('cart-items, form[action="/cart"]');
              if (cartForm) location.reload();
            }, 800);
          })
          .catch(function () {
            atcBtn.textContent = 'Error';
            setTimeout(function () { atcBtn.textContent = '+ Add'; atcBtn.disabled = false; atcBtn.style.background = '#113B2B'; }, 2000);
          });
        });
        actionsRow.appendChild(atcBtn);
        infoWrap.appendChild(actionsRow);
        card.appendChild(infoWrap);
        productsWrap.appendChild(card);
      });

      banner.appendChild(productsWrap);
    } else if (tier >= 3) {
      // Show a "complete" confirmation
      var complete = document.createElement('div');
      complete.className = 'scu-complete';
      complete.innerHTML = '<span class="scu-check">\u2713</span>';
      var label = document.createElement('span');
      label.style.cssText = 'font-size:13px;color:#113B2B;font-family:"Poppins",sans-serif;';
      label.textContent = 'All 3 SoiLife products in your cart';
      complete.appendChild(label);
      banner.appendChild(complete);
    }

    // Inject into the DOM
    injectIntoDom(banner);
  }

  // ── DOM injection targets ───────────────────────────────────────────
  function injectIntoDom(banner) {
    var inserted = false;

    // Cart DRAWER: try .drawer__inner first (Dawn standard)
    var drawerInner = document.querySelector('.drawer__inner');
    if (drawerInner) {
      var drawerHeader = drawerInner.querySelector('.drawer__header');
      if (drawerHeader && drawerHeader.nextElementSibling) {
        // Insert after the header
        drawerHeader.parentNode.insertBefore(banner, drawerHeader.nextElementSibling);
        inserted = true;
      } else if (drawerInner.firstChild) {
        drawerInner.insertBefore(banner, drawerInner.firstChild);
        inserted = true;
      }
    }

    // Cart PAGE: prepend into the cart items area
    var cartItems = document.getElementById('main-cart-items');
    if (cartItems) {
      // If we already inserted in drawer, clone for the page
      var pageBanner = inserted ? banner.cloneNode(true) : banner;
      if (inserted) {
        // Re-attach dismiss listener on clone
        var cloneDismiss = pageBanner.querySelector('.scu-dismiss');
        if (cloneDismiss) {
          cloneDismiss.addEventListener('click', function () {
            sessionStorage.setItem(DISMISSED_KEY, '1');
            removeBanner();
          });
        }
        pageBanner.id = BANNER_ID + '-page';
      }
      cartItems.insertBefore(pageBanner, cartItems.firstChild);
      inserted = true;
    }

    // Fallback: try cart-items element or .cart__items
    if (!inserted) {
      var fallback = document.querySelector('cart-items') ||
                     document.querySelector('.cart__items') ||
                     document.querySelector('.cart-items');
      if (fallback) {
        fallback.insertBefore(banner, fallback.firstChild);
      }
    }
  }

  // ── Remove banner ───────────────────────────────────────────────────
  function removeBanner() {
    var el = document.getElementById(BANNER_ID);
    if (el && el.parentNode) el.parentNode.removeChild(el);

    var elPage = document.getElementById(BANNER_ID + '-page');
    if (elPage && elPage.parentNode) elPage.parentNode.removeChild(elPage);
  }

  // ── Listen for cart changes ─────────────────────────────────────────
  // Uses custom event from soilife-cart-confirm.js (which owns the fetch wrapper)
  // Also listens for XHR-based cart changes (Foxify, other apps)
  function listenForCartChanges() {
    // Listen for custom event dispatched by cart-confirm's fetch wrapper
    document.addEventListener('soilife:cart:added', function () {
      setTimeout(fetchCartAndRender, 300);
    });

    // XHR interception for non-fetch cart changes (Foxify, third-party apps)
    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this._soiUrl = url || '';
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      var self = this;
      var url = self._soiUrl;

      if (
        url.indexOf('/cart/add') !== -1 ||
        url.indexOf('/cart/change') !== -1 ||
        url.indexOf('/cart/update') !== -1 ||
        url.indexOf('/cart/clear') !== -1
      ) {
        self.addEventListener('load', function () {
          setTimeout(fetchCartAndRender, 300);
        });
      }

      return originalSend.apply(this, arguments);
    };
  }

  // ── Initialise ──────────────────────────────────────────────────────
  function init() {
    listenForCartChanges();
    fetchCartAndRender();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
